import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';

export interface AccountPersistState {
    skipNextClose: boolean;
    skipNextOpen: boolean;
    panelStateByScenario: Map<string, boolean>;
}

const stateByAccount = new Map<string, AccountPersistState>();

export function getOrCreatePersistState(mailboxInfo: MailboxInfo): AccountPersistState {
    const key = getAccountKeyForMailboxInfo(mailboxInfo);
    let entry = stateByAccount.get(key);
    if (!entry) {
        entry = {
            skipNextClose: false,
            skipNextOpen: false,
            panelStateByScenario: new Map(),
        };
        stateByAccount.set(key, entry);
    }
    return entry;
}

export function setSkipNextCloseForWorkloadSwitch(mailboxInfo: MailboxInfo): void {
    getOrCreatePersistState(mailboxInfo).skipNextClose = true;
}
